var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolsSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.8667 24.7871L15.5167 17.4371C14.9333 17.9038 14.2625 18.2732 13.5042 18.5454C12.7458 18.8177 11.9389 18.9538 11.0833 18.9538C8.96389 18.9538 7.17033 18.2196 5.70267 16.7511C4.235 15.2827 3.50078 13.4891 3.5 11.3704C3.49922 9.25178 4.23344 7.45822 5.70267 5.98978C7.17189 4.52133 8.96544 3.78711 11.0833 3.78711C13.2012 3.78711 14.9952 4.52133 16.4652 5.98978C17.9352 7.45822 18.669 9.25178 18.6667 11.3704C18.6667 12.226 18.5306 13.0329 18.2583 13.7913C17.9861 14.5496 17.6167 15.2204 17.15 15.8038L24.5 23.1538L22.8667 24.7871ZM11.0833 16.6204C12.5417 16.6204 13.7814 16.1102 14.8027 15.0898C15.8239 14.0693 16.3341 12.8296 16.3333 11.3704C16.3326 9.91133 15.8223 8.67194 14.8027 7.65228C13.783 6.63261 12.5432 6.122 11.0833 6.12044C9.62344 6.11889 8.38406 6.6295 7.36517 7.65228C6.34628 8.67505 5.83567 9.91444 5.83333 11.3704C5.831 12.8264 6.34161 14.0662 7.36517 15.0898C8.38872 16.1133 9.62811 16.6236 11.0833 16.6204Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolsSearch);
export default __webpack_public_path__ + "static/media/symbols_search.0a36fadf7e32abdefacac69282d298ad.svg";
export { ForwardRef as ReactComponent };